import { IPageState } from '../../types/redux/page';

export const defaultState: IPageState = {
  deviceType: 'desktop' as const,
};

export function pageReducer(state: IPageState = defaultState): IPageState {
  return state;
}
